<template>
  <v-card outlined class="mb-4 pa-3" color="#f8f9fa">
    <!-- انتخاب منبع فایل -->
    <v-select
      v-model="selectedSource"
      :items="sourceOptions"
      item-text="text"
      item-value="value"
      label="انتخاب روش افزودن تصویر"
      outlined
      dense
      color="primary"
      class="mb-3 font-weight-bold"
      hide-details
    ></v-select>

    <v-divider class="mb-4"></v-divider>

    <div
      v-if="value.length > 0"
      class="text-center mb-3 font-weight-bold"
      style="color: #001554"
    >
      <v-icon color="primary" small class="me-1">
        {{ multiple ? "mdi-file-document-multiple" : "mdi-file-document" }}
      </v-icon>
      {{
        multiple
          ? `${value.length} عکس برای چیدمان آماده است`
          : "۱ عکس انتخاب شده است"
      }}
    </div>

    <!-- حالت ۱: آپلودسنتر -->
    <template v-if="selectedSource === 'uploadCenter'">
      <PicSelector
        v-model="picSelectorData"
        :edit-name="false"
        single
        :one-pic="!multiple"
        default-cat-name="Layout"
      />
    </template>

    <!-- حالت ۲: فایل لوکال -->
    <template v-if="selectedSource === 'local'">
      <local-image-uploader
        v-model="localFilesData"
        :multiple="multiple"
        @input="extractLocalImages"
      />
    </template>

    <!-- حالت ۳: دیجی‌کالا -->
    <template v-if="selectedSource === 'digikala'">
      <v-alert
        border="left"
        color="success"
        colored-border
        class="white elevation-1"
      >
        این فایل را داخل Tampermonkey قرار دهید:
        <a
          href="js/Digikala Image Collector-1.0.user.js"
          style="text-decoration: none; color: #4caf50; font-weight: bold"
        >
          دانلود فایل
        </a>
      </v-alert>

      <div class="text-right mb-2 font-weight-bold" style="color: #001554">
        <v-icon color="primary" small class="me-1">mdi-link</v-icon>
        وارد کردن لینک از دیجی‌کالا
      </div>
      <v-textarea
        v-model="digikalaLinks"
        outlined
        dense
        rows="3"
        :placeholder="
          multiple
            ? 'لینک‌های کپی شده را Paste کنید...'
            : 'یک لینک اینجا Paste کنید...'
        "
        hide-details
        class="mb-3"
      ></v-textarea>
      <v-btn
        class="btn-get-code rounded-lg mx-0"
        block
        @click="importDigikalaLinks"
      >
        <v-icon left>mdi-plus</v-icon>
        {{ multiple ? "اضافه کردن به لیست" : "انتخاب این عکس" }}
      </v-btn>
    </template>

    <div v-if="isLoadingFiles" class="text-center mt-2">
      <v-progress-circular
        indeterminate
        color="primary"
        size="24"
      ></v-progress-circular>
      <span class="ms-2 text-caption">در حال خواندن عکس‌ها...</span>
    </div>
  </v-card>
</template>

<script>
import PicSelector from "@/view/components/UploadCenter/picSelector";
import LocalImageUploader from "./LocalImageUploader.vue";

export default {
  name: "QrPhotoSelector",
  components: {
    PicSelector,
    LocalImageUploader,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    digi: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sourceOptions() {
      if (this.digi)
        return [
          { text: "آپلود فایل از سیستم", value: "local" },
          { text: "انتخاب از آپلودسنتر", value: "uploadCenter" },
          { text: "وارد کردن از دیجی‌کالا", value: "digikala" },
        ];
      else {
        return [
          { text: "آپلود فایل از سیستم", value: "local" },
          { text: "انتخاب از آپلودسنتر", value: "uploadCenter" },
        ];
      }
    },
  },
  data() {
    return {
      selectedSource: "local",

      digikalaLinks: "",
      isLoadingFiles: false,
      picSelectorData: [{ name: "", images: [] }],
      localFilesData: [],
    };
  },
  watch: {
    picSelectorData: {
      deep: true,
      handler(newVal) {
        this.extractImages(newVal);
      },
    },
  },
  methods: {
    importDigikalaLinks() {
      if (!this.digikalaLinks) return;

      let parsedUrls = [];
      try {
        parsedUrls = JSON.parse(this.digikalaLinks);
      } catch (error) {
        parsedUrls = this.digikalaLinks
          .split(/[\n,\s]+/)
          .map((link) => link.trim())
          .filter((link) => link.startsWith("http"));
      }

      if (
        !Array.isArray(parsedUrls) &&
        typeof parsedUrls === "string" &&
        parsedUrls.startsWith("http")
      ) {
        parsedUrls = [parsedUrls];
      }

      if (Array.isArray(parsedUrls) && parsedUrls.length > 0) {
        if (!this.multiple) {
          parsedUrls = [parsedUrls[0]];
        }

        const mappedUrls = parsedUrls.map((url) => ({ url: url }));
        const newList = this.multiple
          ? [...this.value, ...mappedUrls]
          : mappedUrls;

        this.$emit("input", newList);
        this.digikalaLinks = "";
        this.$toast.success("لینک(ها) با موفقیت اضافه شد!");
      } else {
        this.$toast.error(
          "فرمت لینک‌ها نامعتبر است. لطفاً لینک‌های صحیح وارد کنید.",
        );
      }
    },

    extractImages(galleries) {
      this.isLoadingFiles = true;
      try {
        let allImages = [];
        if (galleries && galleries.length) {
          galleries.forEach((gallery) => {
            if (gallery.images && gallery.images.length) {
              allImages.push(...gallery.images);
            }
          });
        }
        let extracted = allImages
          .map((img) =>
            img && img.url ? { url: img.url, name: img.name || "" } : null,
          )
          .filter((item) => item !== null);

        if (!this.multiple && extracted.length > 0) {
          extracted = [extracted[extracted.length - 1]];
        }

        this.$emit("input", extracted);
      } finally {
        this.isLoadingFiles = false;
      }
    },
    extractLocalImages(files) {
      if (!files) return;
      let extracted = files.map((fileData) => ({
        url: fileData.url,
        name: fileData.name,
      }));

      if (!this.multiple && extracted.length > 0) {
        extracted = [extracted[extracted.length - 1]];
      }
      this.$emit("input", extracted);
    },
  },
};
</script>
